import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames/bind';
import { Example, Tip } from 'examples';
import Group from '../../src/components/Group/Group';

const Color = ({ className, info, title, variable }) =>
  <div className={cx('color', variable, className)}>
    <div className="info">
      <h4>{title}</h4>
      <span className="variable">${variable}</span>
      <p className="description">{info}</p>
    </div>
  </div>;

Color.propTypes = {
  className: PropTypes.string,
  info: PropTypes.string,
  title: PropTypes.string,
  variable: PropTypes.string,
};

export default class Colors extends PureComponent {

  render() {
    return (
      <Example title="Colors" className="no-props no-code-example">
        <Group title="Primary Colors">
          <div className="color-strip">
            <Color title="Orange" variable="color-primary-1" info="Use as primary action color, active and focused state, and navigation."/>
            <Color title="Dark blue" variable="color-primary-2" info="Use as background in main navigation, headers and dashboards."/>
          </div>
        </Group>
        <Group title="Secondary Colors">
          <div className="color-strip">
            <Color title="Semi dark blue" variable="color-secondary-1" info="Use as background in action menus and as default color for buttons etc."/>
            <Color title="White" variable="color-secondary-2" info="Use as alternate main background color or foreground color on inverted backgrounds." className="border"/>
            <Color title="Gray" variable="color-secondary-3" info="Use on labels."/>
            <Color title="Light gray" variable="color-secondary-4" info="Use as main background color." className="border"/>
          </div>
        </Group>
        <Group title="State Colors">
          <div className="color-strip">
            <Color title="Blue" variable="color-state-1" info="Use as selection background color."/>
            <Color title="Turquise" variable="color-state-2" info="Use on switch on, radio button on, checkbox on."/>
            <Color title="Red" variable="color-state-3" info="Use on errors and pending states."/>
            <Color title="Lilac" variable="color-state-4" info="Use on archived items."/>
            <Color title="Yellow" variable="color-state-5" info="Use on draft items."/>
          </div>
        </Group>
        <Tip>
          See <a href="https://github.com/vimond/vimond-core-components/blob/master/src/css/vimond-profile.scss">vimond-profile.scss</a> for
          more variables and colors. Import this file in your master SCSS to use these variables.
        </Tip>
        {/* <hr className="page-separator"/>
        <Group title="Text and background colors">
          <p>
            For dark text on light backgrounds, apply the following opacity levels:
          </p>
          <ul>
            <li><strong>100%</strong> opacity for the most important text.</li>
            <li><strong>50%</strong> opacity for secondary text.</li>
            <li><strong>30%</strong> opacity for placeholders and labels.</li>
          </ul>
        </Group> */}
      </Example>
    );
  }

}
